import { cn } from '@listening/utils/react-helpers';
import { Button as ReactButton } from '@listening/frontend/components/radix/button';
import type { ComponentProps } from 'react';

const defaultClassName =
  'rounded-full bg-black px-8 py-7 text-xl font-light text-white hover:bg-black/80 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-blue-500';

// Define the gradient animation style inline
const gradientStyle = {
  '--gradient-animation': `linear-gradient(
    to right,
    #EC0C92 0%,
    #1820D9 25%,
    #1C92FF 50%,
    #00FFE0 75%,
    #EC0C92 100%
    )`,
};
export function Button({
  class: className,
  href,
  gradient = false,
  targetBlank = false,
  ariaLabel,
  role = 'button',
  ...props
}: {
  class?: string;
  href?: string;
  gradient?: boolean;
  targetBlank?: boolean;
  ariaLabel?: string;
  role?: string;
} & ComponentProps<typeof ReactButton>) {
  return (
    <div className='relative'>
      {gradient ? (
        <div
          className='relative overflow-hidden rounded-full p-[3px]'
          role='presentation'
        >
          <div
            aria-hidden='true'
            className='absolute inset-[-3px] animate-[border-shine_4s_linear_infinite] rounded-full'
            style={{
              background: gradientStyle['--gradient-animation'],
              backgroundSize: '200% auto',
            }}
          />
          <ReactButton
            aria-label={ariaLabel}
            className={cn(defaultClassName, 'relative', className)}
            role={role}
            {...props}
          >
            {href ? (
              <a
                aria-label={ariaLabel}
                className='block w-full'
                href={href}
                rel={targetBlank ? 'noopener noreferrer' : undefined}
                target={targetBlank ? '_blank' : undefined}
              >
                <slot />
              </a>
            ) : (
              <slot />
            )}
          </ReactButton>
        </div>
      ) : (
        <ReactButton
          aria-label={ariaLabel}
          className={cn(defaultClassName, className)}
          role={role}
          {...props}
        >
          {href ? (
            <a
              aria-label={ariaLabel}
              className='block w-full'
              href={href}
              rel={targetBlank ? 'noopener noreferrer' : undefined}
              target={targetBlank ? '_blank' : undefined}
            >
              <slot />
            </a>
          ) : (
            <slot />
          )}
        </ReactButton>
      )}
    </div>
  );
}
